// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const BarChartGroupedIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="BarChartGroupedIcon" ref={forwardedRef} {...props}>
      <path d="M4.5 3H3v13a1 1 0 0 0 1 1h13v-1.5H4.5z" />
      <path d="M8.75 4h1.6v10h-1.6z" />
      <path d="M12.5 6h1.6v8h-1.6z" />
      <path d="M7.6 7H6v7h1.6z" />
      <path d="M17 14h-1.6V9H17z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const BarChartGroupedIcon = /* @__PURE__ */ Object.assign(
  BarChartGroupedIconComponent,
  { displayName: 'BarChartGroupedIcon' },
);
